import { ApplicationRef, Injectable, NgZone } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';

let requestFlush: () => void = () => undefined;
let requestDeferredFlush: () => void = () => undefined;

export function requestApiRenderFlush(): void {
    requestFlush();
}

/** Schedules CD ticks after NSwag FileReader parses blob responses (zone.js 0.15+ does not patch FileReader). */
export function requestDeferredApiRenderFlush(): void {
    requestDeferredFlush();
}

@Injectable({
    providedIn: 'root',
})
export class ApiRenderFlushService {
    private flushScheduled = false;
    private deferredParseFlushTimeoutIds: ReturnType<typeof setTimeout>[] = [];

    constructor(
        private readonly appRef: ApplicationRef,
        private readonly ngZone: NgZone,
        private readonly spinnerService: NgxSpinnerService
    ) {
        requestFlush = () => this.scheduleFlush();
        requestDeferredFlush = () => this.scheduleDeferredParseFlush();
    }

    private scheduleDeferredParseFlush(): void {
        this.deferredParseFlushTimeoutIds.forEach((id) => clearTimeout(id));
        this.deferredParseFlushTimeoutIds = [];

        this.ngZone.runOutsideAngular(() => {
            for (const delayMs of [0, 16, 50, 150]) {
                const timeoutId = setTimeout(() => {
                    this.ngZone.run(() => {
                        void this.spinnerService.hide();
                        this.appRef.tick();
                    });
                }, delayMs);
                this.deferredParseFlushTimeoutIds.push(timeoutId);
            }
        });
    }

    private scheduleFlush(): void {
        if (this.flushScheduled) {
            return;
        }

        this.flushScheduled = true;
        this.ngZone.runOutsideAngular(() => {
            let timeoutId: ReturnType<typeof setTimeout>;
            let animationFrameId: number;

            const flush = () => {
                clearTimeout(timeoutId);
                cancelAnimationFrame(animationFrameId);

                this.ngZone.run(() => {
                    this.flushScheduled = false;
                    void this.spinnerService.hide();
                    this.appRef.tick();
                    window.dispatchEvent(new Event('resize'));
                });
            };

            timeoutId = setTimeout(flush, 0);
            animationFrameId = requestAnimationFrame(flush);
        });
    }
}
